﻿import React, { useState, useEffect } from 'react';
import { AppearanceBenchSheet } from '../../models/BenchSheets/appearance-bench-sheet';
import { AppearanceColor } from '../../models/BenchSheets/appearance-color';
import { LookupItem } from '../../models/lookup-item';
import { NoteType, AppearanceFormTypes } from '../../models/enums';
import NoteViewer from '../NoteViewer';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';

import SelectBox from 'devextreme-react/select-box';
import Button from 'devextreme-react/button';
import CheckBox from 'devextreme-react/check-box';
import RadioGroup from 'devextreme-react/radio-group'
import { FieldUpdate } from '../../models/field-update';

const formTypes = [
    { id: AppearanceFormTypes.Solid, name: "Solid" },
    { id: AppearanceFormTypes.Liquid, name: "Liquid" }
]

let key = 1;

export interface Props {
    batchId?: string;
    canEdit?: boolean;
}

export default function AppearanceBenchSheetComponent(props: Props) {
    const [benchSheet, setBenchSheet] =
        useState<AppearanceBenchSheet>();

    const [solidPn91711Colors, setSolidPn91711Colors] =
        useState<AppearanceColor[]>();

    const [liquidColors, setLiquidColors] =
        useState<AppearanceColor[]>();

    const [liquidPn91711Colors, setLiquidPn91711Colors] =
        useState<AppearanceColor[]>();

    const [forms, setForms] =
        useState<LookupItem[]>();

    const [turbidityTypes, setTurbidityTypes] =
        useState<LookupItem[]>();

    const [viscosityTypes, setViscosityTypes] =
        useState<LookupItem[]>();

    const [formattedAppearanceString, setFormattedAppearanceString] =
        useState<string>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    const [dataLoaded, setDataLoaded] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    /*
    useEffect(() => {
        renderAppearanceString();
    });
    */

    key++;

    return (
        <div>

            <div className="pw-form-unit pw-margin-top-1">
                <div className="pw-form-unit-label">Appearance Rendering</div>
                <div className="pw-readonly-label">{formattedAppearanceString}</div>
            </div>

            <Button icon="refresh" type="success" onClick={onRefreshFormattedAppearanceString} />

            <div className='pw-comp-row pw-margin-top-1'>
                <div className="pw-form-unit pw-comp-15">
                    <div className="pw-form-unit-label pw-margin-bottom-05">Form</div>
                    <RadioGroup id="formTypeId" items={formTypes}
                        className="pw-radio-group"
                        displayExpr='name' valueExpr='id' layout="horizontal"
                        onValueChanged={onValueChanged}
                        value={benchSheet && benchSheet.formTypeId ? benchSheet.formTypeId : undefined} />
                </div>
            </div>

            <div className="pw-margin-top-1">
                {(benchSheet && benchSheet.formTypeId === AppearanceFormTypes.Solid) &&
                    <div>
                        <div className="pw-comp-row">
                            <div className="pw-form-unit pw-comp-15">
                                <div className="pw-form-unit-label">Form Color</div>
                                <SelectBox id="colorTypeId" className="selectbox"
                                    placeholder='NA' readOnly={!props.canEdit}
                                    valueExpr='appearanceColorTypeId' displayExpr='fullName'
                                    dataSource={solidPn91711Colors ? solidPn91711Colors : []}
                                    value={benchSheet && benchSheet.colorTypeId ? benchSheet.colorTypeId : undefined}
                                    onValueChanged={onValueChanged} />
                            </div>

                            <div className="pw-form-unit pw-comp-15">
                                <div className="pw-form-unit-label">Form Appearance</div>
                                <SelectBox id="formAppearanceId" className="selectbox"
                                    placeholder='NA' readOnly={!props.canEdit}
                                    displayExpr='name' valueExpr='id'
                                    dataSource={forms ? forms : []}
                                    value={benchSheet && benchSheet.formAppearanceId ? benchSheet.formAppearanceId : undefined}
                                    onValueChanged={onValueChanged} />
                            </div>

                            <div className="pw-form-unit pw-comp-20 pw-margin-top-1">
                                <CheckBox id="extraneousMatterPresent" className="pw-check-box"
                                    text="Extraneous Matter Present"
                                    onValueChanged={onValueChanged}
                                    value={benchSheet && benchSheet.extraneousMatterPresent ?
                                        benchSheet.extraneousMatterPresent : false} />
                            </div>
                        </div>

                        {(benchSheet && benchSheet.extraneousMatterPresent) &&
                            <div className="pw-margin-top-1">
                                <NoteViewer height='8rem' title="Extraneous Matter Note" headerColor="pw-bg-blue"
                                    noteType={NoteType.AppearanceExtraneousMatter} parentId={props.batchId} />
                            </div>
                        }
                    </div>
                }

                {(benchSheet && benchSheet.formTypeId === AppearanceFormTypes.Liquid) &&
                    <>
                        <div className="pw-form-unit">
                            <CheckBox className="pw-check-box" id="brownYellowGreenOrRed"
                                text="Is the material Colorless, Brown, Brown-Yellow, Yellow, Green-Yellow or Red in color?"
                                onValueChanged={onValueChanged}
                                value={benchSheet && benchSheet.brownYellowGreenOrRed ?
                                    benchSheet.brownYellowGreenOrRed : false} />
                        </div>

                        <div className="pw-comp-row pw-margin-top-05">
                            <>
                                {(benchSheet && benchSheet.brownYellowGreenOrRed) &&
                                    <div className="pw-form-unit pw-comp-15">
                                        <div className="pw-form-unit-label">Form Color</div>
                                        <SelectBox id="colorTypeId" className="selectbox"
                                            placeholder='NA' readOnly={!props.canEdit}
                                            displayExpr='fullName' valueExpr='appearanceColorTypeId'
                                            dataSource={liquidColors ? liquidColors : []}
                                            value={benchSheet && benchSheet.colorTypeId ? benchSheet.colorTypeId : undefined}
                                            onValueChanged={onValueChanged} />
                                    </div>
                                }

                                {(benchSheet && !benchSheet.brownYellowGreenOrRed) &&
                                    <div className="pw-form-unit pw-comp-15">
                                        <div className="pw-form-unit-label">Form Color</div>
                                        <SelectBox id="colorTypeId" className="selectbox"
                                            placeholder='NA' readOnly={!props.canEdit}
                                            displayExpr='fullName' valueExpr='appearanceColorTypeId'
                                            dataSource={liquidPn91711Colors ? liquidPn91711Colors : []}
                                            value={benchSheet && benchSheet.colorTypeId ? benchSheet.colorTypeId : undefined}
                                            onValueChanged={onValueChanged} />
                                    </div>
                                }

                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Turbidity</div>
                                    <SelectBox id="turbidityTypeId" className="selectbox"
                                        placeholder='NA' readOnly={!props.canEdit}
                                        displayExpr='name' valueExpr='id'
                                        dataSource={turbidityTypes ? turbidityTypes : []}
                                        value={benchSheet && benchSheet.turbidityTypeId ? benchSheet.turbidityTypeId : undefined}
                                        onValueChanged={onValueChanged} />
                                </div>

                                <div className="pw-form-unit pw-comp-15">
                                    <div className="pw-form-unit-label">Form Viscosity</div>
                                    <SelectBox id="viscosityTypeId" className="selectbox"
                                        placeholder='NA' readOnly={!props.canEdit}
                                        displayExpr='name' valueExpr='id'
                                        dataSource={viscosityTypes ? viscosityTypes : []}
                                        value={benchSheet && benchSheet.viscosityTypeId ? benchSheet.viscosityTypeId : undefined}
                                        onValueChanged={onValueChanged} />
                                </div>
                            </>
                        </div>
                    </>
                }


            </div>

            <div className="pw-margin-top-1 pw-form-unit">
                <NoteViewer height='10rem' title="Appearance Note"
                    noteType={NoteType.Appearance} parentId={props.batchId} />
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div >
    );

    function onRefreshFormattedAppearanceString() {
        getAppearanceFormattedString();
    }

    async function onValueChanged(e: any) {

        console.log("onValueChanged");
        console.log(e);

        if (!dataLoaded || !benchSheet)
            return;

        const caller = e.element.id as string;

        console.log(205);

        if (caller) {
            const currentValue = benchSheet[caller];

            console.log(210);

            if (currentValue === e.value)
                return;
            else if (!currentValue && !e.value)
                return;

            console.log(217);

            setBenchSheet({ ...benchSheet, [caller]: e.value });

            let fieldUpdate: FieldUpdate = {
                entity: "BatchAppearances",
                field: caller,
                value: e.value,
                rowId: props.batchId
            };

            await updateAppearanceField(fieldUpdate)
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Updating Batch Appearance Field");
                });
        }
    }

    //GET methods

    async function getBenchSheet() {
        if (props.batchId) {
            await CrudFunctions.getData(`products/appearancebenchsheet/${props.batchId}`)
                .then((data) => {
                    //console.log("appearance BS:")
                    //console.log(data);

                    setBenchSheet(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Appearance Bench Sheet");
                });
        }
    }

    async function getAppearanceFormattedString() {
        if (props.batchId) {
            await CrudFunctions.getData(`products/appearancebenchsheet/formattedstring/${props.batchId}`)
                .then((data) => {
                    if(data && data.value)
                        setFormattedAppearanceString(data.value);
                        })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Formatted Appearance String");
                });
        }
    }

    async function getAllColorTypes() {
        return await CrudFunctions.getData("benchsheets/appearancecolortypes");
    }

    async function getFormTypes() {
        await CrudFunctions.getData("benchsheets/appearanceformtypes")
            .then((data) => {
                setForms(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Form Types");
            });
    }

    async function getTurbidityTypes() {
        await CrudFunctions.getData("benchsheets/appearanceturbiditytypes")
            .then((data) => {
                setTurbidityTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Turbidity Types");
            });
    }

    async function getViscosityTypes() {
        await CrudFunctions.getData("benchsheets/appearanceviscositytypes")
            .then((data) => {
                setViscosityTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Viscosity Types");
            });
    }

    async function updateAppearanceField(fieldUpdate: FieldUpdate) {
        return await CrudFunctions.putData("products/appearancebenchsheetfield", fieldUpdate);
    }

    async function getColorTypes() {
        await getAllColorTypes()
            .then((colors: AppearanceColor[]) => {
                colors.forEach(c => {
                    c.fullName = `${c.code} - ${c.name}`
                });

                let sc = colors.filter(c => c.form === AppearanceFormTypes.Solid);
                setSolidPn91711Colors(sc);

                let lc = colors.filter(c => c.form === AppearanceFormTypes.Liquid && !c.pn91711);
                setLiquidColors(lc);

                let lcPn91711 = colors.filter(c => c.form === AppearanceFormTypes.Liquid && c.pn91711);
                setLiquidPn91711Colors(lcPn91711);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Color Types");
            });
    }

    async function getAllData() {
        await Promise.all([
            getTurbidityTypes(),
            getViscosityTypes(),
            getColorTypes(),
            getFormTypes(),
            getBenchSheet(),
            getAppearanceFormattedString()
        ])
            .then(() => { setDataLoaded(true) });
    }

    function renderAppearanceString() {
        //console.log("renderAppearanceString()");

        if (!benchSheet || !dataLoaded)
            return;

        let appearance = '';
        let formTypeName = '';
        let formColorName = '';
        let formName = '';
        let turbidityName = '';
        let viscosityName = '';

        if (formTypes) {
            const matchingFormType = formTypes.find(f => f.id === benchSheet.formTypeId);
            formTypeName = matchingFormType ? matchingFormType.name : 'NA';
        }

        if (formTypeName)
            appearance = `Form Type: ${formTypeName},  `;

        if (benchSheet.formTypeId === AppearanceFormTypes.Solid) {

            if (solidPn91711Colors) {
                const matchingColor = solidPn91711Colors.find(c => c.appearanceColorTypeId === benchSheet.colorTypeId);
                formColorName = matchingColor ? matchingColor.name : 'NA';
            }

            appearance += `Color: ${formColorName},  `;

            if (forms) {
                const matchingForm = forms.find(f => f.id === benchSheet.formAppearanceId);
                formName = matchingForm ? matchingForm.name : 'NA';
            }

            appearance += `Form appeance: ${formName},  `;

            if (benchSheet.extraneousMatterPresent)
                appearance += " extraneousMatterPresent, ";
        }
        else if (benchSheet.formTypeId === AppearanceFormTypes.Liquid) {
            if (benchSheet.brownYellowGreenOrRed) {

                if (liquidColors) {
                    const matchingColor = liquidColors.find(c => c.appearanceColorTypeId === benchSheet.colorTypeId);
                    formColorName = matchingColor ? matchingColor.name : 'NA';
                }

                appearance += `Color: ${formColorName},  `;

            }
            else {
                if (solidPn91711Colors) {
                    const matchingColor = solidPn91711Colors.find(c => c.appearanceColorTypeId === benchSheet.colorTypeId);
                    formColorName = matchingColor ? matchingColor.name : 'NA';
                }

                appearance += `Color: ${formColorName},  `;
            }

            if (turbidityTypes) {
                const matchingTurbidityType = turbidityTypes.find(t => t.id === benchSheet.turbidityTypeId);
                turbidityName = matchingTurbidityType ? matchingTurbidityType.name : 'NA';
            }

            appearance += `Turbidity: ${turbidityName},  `;

            if (viscosityTypes) {
                const matchingViscosityType = viscosityTypes.find(v => v.id === benchSheet.viscosityTypeId);
                viscosityName = matchingViscosityType ? matchingViscosityType.name : 'NA';
            }

            appearance += `Viscosity: ${viscosityName},  `;
        }

        setFormattedAppearanceString(appearance);
    }

    // other functions

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

}


